import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiLayout, FiCheckSquare, FiBook, FiUsers, FiShare2, FiUserCheck } = FiIcons;

const Navigation = () => {
  const { user, isTeamOwner } = useAuth();

  const navItems = [
    {
      name: 'Dashboard',
      href: '/dashboard',
      icon: FiLayout,
      description: 'Team-Übersicht',
      tourId: 'nav-dashboard'
    },
    {
      name: 'Netzwerk',
      href: '/network',
      icon: FiShare2,
      description: 'Wirkungsdiagramm',
      tourId: 'nav-network'
    },
    {
      name: 'Bewertungen',
      href: '/evaluations',
      icon: FiCheckSquare,
      description: 'Fragen bewerten',
      tourId: 'nav-evaluations'
    },
    {
      name: 'Handbuch',
      href: '/handbook',
      icon: FiBook,
      description: 'Verbesserungsvorschläge',
      tourId: 'nav-handbook'
    }
  ];

  if (user?.teamId) {
    navItems.push({
      name: 'Team-Feedback',
      href: '/team-feedback',
      icon: FiUserCheck,
      description: 'Feedback geben & erhalten',
      tourId: 'nav-team-feedback'
    });

    navItems.push({
      name: 'Team-Verwaltung',
      href: '/team-management',
      icon: FiUsers,
      description: isTeamOwner ? 'Elemente verwalten' : 'Team verlassen',
      tourId: 'nav-team-management'
    });
  }

  return (
    <nav className="bg-gray-50 border-r border-gray-200 w-64 h-full overflow-y-auto">
      <div className="p-4">
        <ul className="space-y-2">
          {navItems.map((item) => (
            <li key={item.name}>
              <NavLink
                to={item.href}
                data-tour={item.tourId}
                className={({ isActive }) => `flex items-center p-3 rounded-lg transition-all duration-200 group ${
                  isActive 
                    ? 'bg-white shadow-sm text-brand-secondary border-l-4 border-brand-secondary' 
                    : 'text-gray-700 hover:bg-white hover:shadow-sm hover:text-brand-secondary'
                }`}
              >
                {({ isActive }) => (
                  <>
                    <SafeIcon 
                      icon={item.icon} 
                      className={`w-5 h-5 transition-colors ${
                        isActive 
                          ? 'text-brand-secondary' 
                          : 'text-gray-500 group-hover:text-brand-secondary'
                      }`} 
                    />
                    <div className="ml-3">
                      <div className="font-medium">{item.name}</div>
                    </div>
                  </>
                )}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Navigation;